
  import { css } from 'lit';
  export const styles = css`:host{--elevation: var(--ig-tooltip-elevation, var(--ig-elevation-8));--background: var(--ig-tooltip-background, hsl(from var(--ig-gray-600) h s l/0.9));--ig-theme: indigo;--ig-theme-variant: light}`;
  